export default __webpack_public_path__ + "static/media/6.dd225c7e.svg";